<template>
  <div class="clooned">
    
    <div style="overflow: auto;height:316px;">
      <tree    :treedata="forRend"  :fly-tay="false"    :keystree="[]"    @Afffor="treesList"/>
    </div>
    <!-- <el-form
      :model="forRend"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
     <el-form-item label="请选择区域">
          <el-select
              v-model="forRend.area_uuid"
              placeholder="请选择区域"
              @change="mychange"
              style="height:20px;width:100%"
            >
              <el-option
                v-for="item in optionsChiiend"
                :key="item.uuid"
                :label="item.areaname"
                :value="item.uuid"
              ></el-option>
            </el-select>
      </el-form-item> -->
    <!-- </el-form> -->
    
    <span slot="footer" class="dialog-footer list btenEtiel netListn" center style="display:block">
      <el-button @click="dialogVisiblecs('ruleForm')">{{dataobjs.quxiao}}</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">{{dataobjs.baocun}}</el-button>
    </span>
  </div>
</template>

<script>
import {lang_fend} from '@/network/index.js'
import {yidongDataLisnt} from '../../../network/index'
import tree from "@/components/common/tree";
export default {
  components:{
    tree
  },
  props: {
    uuid:{
      type:String,
      default:""
    },
    closefale: {
      type: Function,
      default: Function,
    },
    optionsChiiend:{
        type:Array,
        default:[]
    },
    forRend: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      dataList:{
        area_uuid:''
      },
      dataobjs:{}
    };
  },
  created() {},
  mounted() {
    this.lang_fend()
  },
  computed:{

  },
  methods: {
    treesList(e){
      // console.log(e.area_uuid);
      if(e.area_uuid != undefined){
         this.dataList.area_uuid = e.area_uuid
      }else{
        console.log(e);
        
    this.dataList.area_uuid = ''
      }
     
    },
    // 翻译
        async lang_fend() {
      let page = "gateway_add_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      // console.log(data);
      this.dataobjs = data;
    },
    // 取消
    dialogVisiblecs() {
       this.closefale();
      //  this.$refs.ruleForm.resetFields();
     
    },
    cloneHide(){
       this.$refs.ruleForm.resetFields();
    },
       dialogints() {
       this.$refs.ruleForm.resetFields();
       },
    // 保存
   async submitForm() {
     if(this.dataList.area_uuid != ''){
      this.dataList.uuid = this.uuid
      // console.log(  this.dataList);
      
        const {code,data,msg} = await yidongDataLisnt(this.dataList)
        // console.log(data);
        if(code){
          this.$message.success(msg)
             this.closefale();
             
        }else{
            this.$message.error(msg)
        }
        }else{
          this.$message.error('请选择区域')
        }
        
    },
  },
};
</script>

<style scoped>
.netListn {
  text-align: center;
}
</style>
